import React, { useEffect, useState } from 'react';
import useTranslation from 'next-translate/useTranslation';
import { AlertCircleFilled, Close } from '@eqi-investimentos/icons/web';
import { Flex, Text, Button } from '@eqi-investimentos/react';
import { getCookie, setCookie } from '@/utils/cookies';
import { SIX_HOURS_IN_MS } from '@/utils/date';
export const DisclaimerMarket: React.FC = () => {
  const {
    t: i18n
  } = useTranslation('common');
  const [alreadyViewDisclaimer, setAlreadyViewDisclaimer] = useState(() => getCookie(HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY) === 'true');
  useEffect(() => {
    if (alreadyViewDisclaimer) return;
    setTimeout(() => {
      setCookie(`${HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY}`, 'true', SIX_HOURS_IN_MS);
    }, 6000);
  }, []);
  const handleCloseDisclaimer = () => {
    setAlreadyViewDisclaimer(true);
    setCookie(`${HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY}`, 'true', SIX_HOURS_IN_MS);
  };
  if (alreadyViewDisclaimer) return <></>;
  return <Flex maxW="54.5625rem" alignItems="center" bg="background.brandLight" py="s" px="m" gap="l" borderRadius="xs" data-sentry-element="Flex" data-sentry-component="DisclaimerMarket" data-sentry-source-file="index.tsx">
      <AlertCircleFilled boxSize={24} color="content.brand" data-sentry-element="AlertCircleFilled" data-sentry-source-file="index.tsx" />
      <Text size="l" color="content.primary" data-sentry-element="Text" data-sentry-source-file="index.tsx">
        {i18n('screens.secondariesOpportunities.marketOpeningDisclaimer')}
      </Text>
      <Button variant="naked" w="auto" h="auto" onClick={handleCloseDisclaimer} data-sentry-element="Button" data-sentry-source-file="index.tsx">
        <Close boxSize={24} color="content.brand" data-sentry-element="Close" data-sentry-source-file="index.tsx" />
      </Button>
    </Flex>;
};
export const HAS_VIEWED_DISCLAIMER_OPPORTUNITY_WIDGET_COOKIE_KEY = 'has-viewed-disclaimer-opportunity-widget';